<template>
<div class="config-container">
  <div class="config-header">
    <div :class="['header-tab-item', item.code == current ? 'header-item-selected' : '']" v-for="(item, idx) in menus" :key="idx" @click="clickMenu(item)">{{item.name}}</div>
  </div>
  <div class="config-content">
    <template v-for="(item, idx) in menus">
      <component v-if="item.code == current" :key="idx" v-bind:is="item.com" :args="item.args"></component>
    </template>
  </div>
</div>
</template>
<script>
import SearchLightIndex from './light/Index'
import SearchOnlineGate from './online/Gate'
// import SearchOnlineLight from './online/Light'
// import AnalyseAlarmTypes from './types/Index'
export default {
  name: 'Home',
  components: {
    // AuthMenuItem
  },
  props: {
    sys: {
      type: String,
      default: ''
    },
  },
  data(){
    return {
      current: 's1',
      menus: [
        {code: 's1', name: '单灯历史数据', com: SearchLightIndex, args: {}},
        {code: 's2', name: '网关通信状态记录', com: SearchOnlineGate, args: {}},
        // {code: 's3', name: '单灯通信状态记录', com: SearchOnlineLight, args: {}},
        // {code: 's4', name: '配电柜资产统计', com: AssetAnalyseBox, args: {}},
        // {code: 's5', name: '资产使用单位统计', com: AssetRecordOrgan, args: {}},
        // {code: 's6', name: '资产使用道路统计', com: AssetRecordRoad, args: {}},
        // {code: 's7', name: '资产使用类型统计', com: AssetRecordType, args: {}},
      ],
    }
  },
  watch: {
  },
  mounted: function(){
  },
  methods: {
    clickMenu: function(item){
      this.current = item.code;
    },
  }
}
</script>
<style scoped>
.config-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 5px;
}
.config-header {
  height: 34px;
  flex: none;
  display: flex;
  margin: 15px 0;
}

.header-tab-item {
  border-bottom: 0;
  cursor: pointer;
  padding: 0 10px;
  line-height: 34px;
  background-color: #eef4f9;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #324252;
}
.header-tab-item:first-child {
  border-radius: 6px 0px 0px 0px;
}
.header-tab-item:last-child {
  border-radius: 0px 6px 0px 0px;
}
.header-item-selected {
  background-color: #3880fc;
  color: #ffffff;
}
.config-content {
  height: 500px;
  flex: auto;
}
</style>